import { Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { MapZonesService } from 'app/shared/components';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { MediaSectionHandler } from '../../entities/shared/media.section';
import { MediaService } from 'app/services/media/media.service';


@Component({
    selector: 'key-admin-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss'],
    providers: [MapZonesService],
    standalone: false
})
export class AdminMediaComponent extends BaseComponent implements OnChanges, OnDestroy, AfterViewInit {

    @Input() entity: any;
    @Input() handler: MediaSectionHandler;

    @Input() visible = false;

    errorMessage: string;
    
    asset: string;
    media: { url: string, filename: string, type: string, mimeType: string };

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        private ref: ChangeDetectorRef,
        private mediaService: MediaService
    ) {
        super();
    }

    ngOnDestroy() {

    }


    ngAfterViewInit() {
    }

    ngOnChanges(_changes: SimpleChanges) {
        if (this.handler && this.visible) {
            this.load();
        }
    }

    async load(): Promise<void> {
        try {
            this.media = null;
            this.errorMessage = null;
            if (this.entity) {
                const data = await this.handler.mapEntityToEditor(this.entity);
                if (data.filename) {
                    this.asset = this.entity.asset.id;
                    this.media = {
                        type: data.type,
                        filename: data.filename,
                        mimeType: data.mimeType,
                        url: this.mediaService.getMediaUrl(this.asset, data.filename),
                    };
                }
            } else {
                this.media = null;
            }
        } catch (err) {
            console.error(err);
            this.showError(this.i18n.instant('ADMIN.EDITORS.SHARED.CHART.ERRORS.UNEXPECTED_ERROR'));
        }
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();

    }

    /**
     * If we have an error loading the image, use the place-holder image instead
     * @param _event the error event
     */
    onImageError(_event: Event) {
        this.media.url = 'assets/images/video-thumbnail.png';  
        this.ref.markForCheck();
    }
}
